export enum Deployment {
	LOCAL,
	STAGING_DE,
	DEV_DE,
	DE,
}
